"use client";

import { c as _c } from "react/compiler-runtime";
import type { CicStatement } from "@/entities/IProfile";
import { useState } from "react";
export default function UserPageHeaderAboutStatement(t0) {
  const $ = _c(10);
  const {
    statement
  } = t0;
  const [expanded, setExpanded] = useState(false);
  if (!statement) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-text-sm tw-italic tw-text-white/40 tw-transition tw-duration-200 group-focus-within:tw-text-white/70 group-hover:tw-text-white/70">Click to add an About statement</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const showToggle = statement.statement_value.length > 240;
  const clampClass = expanded ? "tw-line-clamp-none" : "tw-line-clamp-6 md:tw-line-clamp-none";
  const t1 = `tw-mb-0 tw-whitespace-pre-line tw-text-md tw-font-medium tw-leading-relaxed tw-text-iron-200 ${clampClass}`;
  let t2;
  if ($[1] !== statement.statement_value || $[2] !== t1) {
    t2 = <div className={t1}>{statement.statement_value}</div>;
    $[1] = statement.statement_value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== expanded || $[5] !== showToggle) {
    t3 = showToggle && <button type="button" onClick={event => {
      event.stopPropagation();
      setExpanded(_temp);
    }} className="tw-border-0 tw-bg-transparent tw-px-1 tw-py-1 tw-text-sm tw-font-semibold tw-text-white/80 tw-transition tw-duration-200 tw-ease-out hover:tw-text-white md:tw-hidden">{expanded ? "See less" : "See more"}</button>;
    $[4] = expanded;
    $[5] = showToggle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-space-y-2">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(prev) {
  return !prev;
}